import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, TransitionGroup as _TransitionGroup, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-784ffb85"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mb-2 d-none d-lg-block",
  style: {"width":"960px","height":"176px"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Sign Up For This Tour!", -1))
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-wrap mt-n1 ms-n2"
}
const _hoisted_5 = {
  class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center",
  style: {"min-width":"15%"}
}
const _hoisted_6 = { class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center" }
const _hoisted_7 = {
  class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center",
  style: {"min-width":"20%"}
}
const _hoisted_8 = {
  key: 1,
  class: "white-box-1"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Tour Leader Contact Information:", -1))
const _hoisted_10 = {
  key: 0,
  style: {"white-space":"pre-wrap"}
}
const _hoisted_11 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " To sign up for the tour you were just viewing, we can help you two ways: ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("Contact the tour leader using the details above, "),
  /*#__PURE__*/_createElementVNode("b", null, "or")
], -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Click \"Add Passenger\" below for every passenger wanting to sign up and fill in the boxes for each.")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Then click the 'Submit' button. This will send a message to the tour leader that you are requesting to join the tour.")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Please note, there can only be a maximum of three passengers per room and passengers can be moved to other rooms by dragging their name. ")
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Address and date of birth are required by one or more casinos on this tour. ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { class: "d-flex flex-wrap" }
const _hoisted_25 = { class: "room-label" }
const _hoisted_26 = ["onDragenter", "onDrop"]
const _hoisted_27 = ["onDragstart"]
const _hoisted_28 = { class: "pax-button" }
const _hoisted_29 = { class: "pax-button-name" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  class: "pax-details",
  draggable: "true",
  ondragstart: "return false;"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Full first and last name is required" }, "Name*:", -1))
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = ["title", "onUpdate:modelValue"]
const _hoisted_35 = ["title", "onUpdate:modelValue"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Enter your email address to receive communication electronically" }, " Email: ", -1))
const _hoisted_37 = ["title", "onUpdate:modelValue"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "A phone number is required for at least one passenger" }, " Phone*: ", -1))
const _hoisted_39 = ["title", "value", "onMaska"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Home street address is required for one or more casinos on this tour" }, [
  /*#__PURE__*/_createTextVNode(" Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Line 1*: ")
], -1))
const _hoisted_41 = ["title", "onUpdate:modelValue"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Line 2:")
], -1))
const _hoisted_43 = ["title", "onUpdate:modelValue"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Home city and state is required for one or more casinos on this tour" }, " City, State*: ", -1))
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = ["title", "onUpdate:modelValue"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Home zip code is required for one or more casinos on this tour" }, " Zip*: ", -1))
const _hoisted_48 = ["title", "onUpdate:modelValue"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { title: "Date of birth is required for one or more casinos on this tour" }, " Date of Birth*: ", -1))
const _hoisted_50 = ["title", "onUpdate:modelValue"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Notes/ Requests:", -1))
const _hoisted_52 = ["title", "onUpdate:modelValue"]
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  colspan: "2",
  class: "text-center"
}
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Request two beds: ")
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = {
  colspan: "2",
  class: "text-center"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Notify me about future trips: ")
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = {
  key: 0,
  class: "pax-container"
}
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pax-button-name" }, "Add Passenger", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pax-action pax-add" }, "+", -1))
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = {
  key: 0,
  class: "room-container room-new"
}
const _hoisted_66 = { class: "room-label" }
const _hoisted_67 = { class: "pax-container" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pax-button-name" }, "Add Passenger", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pax-action pax-add" }, "+", -1))
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = { class: "text-center" }
const _hoisted_72 = ["href"]
const _hoisted_73 = { key: 4 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Thank you!"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Thank you for expressing interest in joining this trip. Your tour leader will be in touch as soon as possible. Please note that this is "),
    /*#__PURE__*/_createElementVNode("b", null, [
      /*#__PURE__*/_createElementVNode("u", null, "not")
    ]),
    /*#__PURE__*/_createTextVNode(" a reservation. ")
  ])
], -1))
const _hoisted_75 = { class: "white-box-1" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Provided Details:", -1))
const _hoisted_77 = { class: "d-flex flex-wrap" }
const _hoisted_78 = { class: "room-label" }
const _hoisted_79 = { class: "room-inner d-flex flex-wrap" }
const _hoisted_80 = { class: "pax-button" }
const _hoisted_81 = { class: "pax-button-name" }
const _hoisted_82 = { class: "pax-details" }
const _hoisted_83 = {
  cellspacing: "5",
  style: {"border-collapse":"unset"}
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Email:", -1))
const _hoisted_85 = {
  width: "75%",
  class: "border"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Phone:", -1))
const _hoisted_87 = { class: "border" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Address:", -1))
const _hoisted_89 = { class: "border" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "City/State:", -1))
const _hoisted_93 = { class: "border" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Zip:", -1))
const _hoisted_95 = { class: "border" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Date of Birth:", -1))
const _hoisted_97 = { class: "border" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Notes/ Requests:", -1))
const _hoisted_99 = { class: "border" }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = {
  colspan: "2",
  class: "text-center"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Request two beds:", -1))
const _hoisted_103 = {
  colspan: "2",
  class: "text-center"
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Notify me about future trips:", -1))
const _hoisted_105 = { class: "text-center" }
const _hoisted_106 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicHeader = _resolveComponent("PublicHeader")!
  const _component_StateSelect = _resolveComponent("StateSelect")!
  const _component_ModalLoading = _resolveComponent("ModalLoading")!
  const _component_ModalErrorMessage = _resolveComponent("ModalErrorMessage")!
  const _directive_focus = _resolveDirective("focus")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PublicHeader, {
      "gt-url": '/' + _ctx.$route.params.gtUrl,
      "organization-name": _ctx.trip?.organizationName
    }, null, 8, ["gt-url", "organization-name"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.trip)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "rounded-2",
            src: _ctx.trip.headerImageUrl
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3,
    (_ctx.trip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, " Tour #: " + _toDisplayString(_ctx.trip.tourId), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.trip.tourName), 1),
          _createElementVNode("div", _hoisted_7, " Tour Dates: " + _toDisplayString(_ctx.tripDates), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.submitted)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          _createElementVNode("div", null, [
            _hoisted_9,
            (_ctx.trip)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.trip.contactDetails), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.submitted)
      ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("ol", null, [
            _hoisted_13,
            _createElementVNode("li", null, [
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              (_ctx.trip?.casinoManifest)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_22))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.submitted)
      ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (roomSignups, roomNum, roomIdx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "room-container w-100",
                key: roomNum
              }, [
                _createElementVNode("div", _hoisted_25, " Room " + _toDisplayString(_ctx.roomNumToChar(roomIdx + 1)) + " - " + _toDisplayString(_ctx.roomType(roomSignups.length)), 1),
                _createElementVNode("div", {
                  class: "room-inner d-flex flex-wrap",
                  dropzone: "move",
                  onDragenter: ($event: any) => (_ctx.dragOver($event, roomNum)),
                  onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                  onDragleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dragOut($event))),
                  onDrop: ($event: any) => (_ctx.dragDrop(roomNum))
                }, [
                  _createVNode(_TransitionGroup, { name: "slide-fade" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomSignups, (signup) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "pax-container",
                          draggable: "true",
                          onDragstart: ($event: any) => (_ctx.startDrag($event, signup)),
                          onDragend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dragEnd && _ctx.dragEnd(...args))),
                          key: signup.clientId
                        }, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(signup.firstName || signup.lastName
                    ? signup.firstName + " " + signup.lastName
                    : "New Passenger"), 1),
                            _createElementVNode("span", {
                              class: "pax-action pax-delete",
                              onClick: ($event: any) => (_ctx.removePassenger(signup)),
                              draggable: "true",
                              ondragstart: "return false;",
                              title: "Click to remove passenger"
                            }, "X", 8, _hoisted_30)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("table", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_32,
                                _createElementVNode("td", _hoisted_33, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    placeholder: "First",
                                    class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'FirstName', signup.clientId) }]),
                                    title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'FirstName', signup.clientId),
                                    autocomplete: "off",
                                    "onUpdate:modelValue": ($event: any) => ((signup.firstName) = $event)
                                  }, null, 10, _hoisted_34), [
                                    [_directive_focus],
                                    [
                                      _vModelText,
                                      signup.firstName,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    placeholder: "Last",
                                    class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'LastName', signup.clientId) }]),
                                    title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'LastName', signup.clientId),
                                    autocomplete: "off",
                                    "onUpdate:modelValue": ($event: any) => ((signup.lastName) = $event)
                                  }, null, 10, _hoisted_35), [
                                    [
                                      _vModelText,
                                      signup.lastName,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_36,
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "email",
                                    class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'Email', signup.clientId) }]),
                                    title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'Email', signup.clientId),
                                    "onUpdate:modelValue": ($event: any) => ((signup.email) = $event)
                                  }, null, 10, _hoisted_37), [
                                    [
                                      _vModelText,
                                      signup.email,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_38,
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "tel",
                                    class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'Phone', signup.clientId) }]),
                                    title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'Phone', signup.clientId),
                                    value: _ctx.formatPhone(signup.phone),
                                    placeholder: "(555) 123-4567",
                                    onMaska: ($event: any) => (
                          signup.phone = $event.target.dataset.maskRawValue
                        )
                                  }, null, 42, _hoisted_39), [
                                    [_directive_maska, '(###) ###-####']
                                  ])
                                ])
                              ]),
                              (_ctx.trip?.casinoManifest)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_40,
                                      _createElementVNode("td", null, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'AddressLine1', signup.clientId) }]),
                                          title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'AddressLine1', signup.clientId),
                                          "onUpdate:modelValue": ($event: any) => ((signup.addressLine1) = $event)
                                        }, null, 10, _hoisted_41), [
                                          [
                                            _vModelText,
                                            signup.addressLine1,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_42,
                                      _createElementVNode("td", null, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'AddressLine2', signup.clientId) }]),
                                          title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'AddressLine2', signup.clientId),
                                          "onUpdate:modelValue": ($event: any) => ((signup.addressLine2) = $event)
                                        }, null, 10, _hoisted_43), [
                                          [
                                            _vModelText,
                                            signup.addressLine2,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_44,
                                      _createElementVNode("td", _hoisted_45, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'City', signup.clientId) }]),
                                          title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'City', signup.clientId),
                                          placeholder: "City",
                                          "onUpdate:modelValue": ($event: any) => ((signup.City) = $event)
                                        }, null, 10, _hoisted_46), [
                                          [
                                            _vModelText,
                                            signup.City,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ]),
                                        _createVNode(_component_StateSelect, {
                                          modelValue: signup.State,
                                          "onUpdate:modelValue": ($event: any) => ((signup.State) = $event),
                                          class: _normalizeClass({ 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'State', signup.clientId) }),
                                          title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'State', signup.clientId)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "title"])
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_47,
                                      _createElementVNode("td", null, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "number",
                                          class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'PostalCode', signup.clientId) }]),
                                          title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'PostalCode', signup.clientId),
                                          "onUpdate:modelValue": ($event: any) => ((signup.postalCode) = $event)
                                        }, null, 10, _hoisted_48), [
                                          [
                                            _vModelText,
                                            signup.postalCode,
                                            void 0,
                                            { trim: true }
                                          ],
                                          [_directive_maska, '#####']
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_49,
                                      _createElementVNode("td", null, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "date",
                                          class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'DateOfBirth', signup.clientId) }]),
                                          title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'DateOfBirth', signup.clientId),
                                          "onUpdate:modelValue": ($event: any) => ((signup.dateOfBirth) = $event)
                                        }, null, 10, _hoisted_50), [
                                          [
                                            _vModelText,
                                            signup.dateOfBirth,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ])
                                      ])
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createElementVNode("tr", null, [
                                _hoisted_51,
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'Notes', signup.clientId) }]),
                                    title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'Notes', signup.clientId),
                                    "onUpdate:modelValue": ($event: any) => ((signup.notes) = $event)
                                  }, null, 10, _hoisted_52), [
                                    [
                                      _vModelText,
                                      signup.notes,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ])
                              ]),
                              (roomSignups.length > 1)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                                    _createElementVNode("th", _hoisted_54, [
                                      _hoisted_55,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        class: "form-check-input",
                                        "onUpdate:modelValue": ($event: any) => ((signup.twoBeds) = $event)
                                      }, null, 8, _hoisted_56), [
                                        [_vModelCheckbox, signup.twoBeds]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_57, [
                                  _hoisted_58,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "form-check-input",
                                    "onUpdate:modelValue": ($event: any) => ((signup.futureTripsNotify) = $event)
                                  }, null, 8, _hoisted_59), [
                                    [_vModelCheckbox, signup.futureTripsNotify]
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 40, _hoisted_27))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024),
                  (roomSignups.length < 3 && _ctx.signups.length < 54)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", {
                          class: "pax-button pax-button-add",
                          onClick: ($event: any) => (_ctx.addPassenger(roomNum)),
                          title: "Click to add passenger"
                        }, _hoisted_64, 8, _hoisted_61)
                      ]))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_26)
              ]))
            }), 128)),
            (_ctx.roomCount < 26 && _ctx.signups.length < 54)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, " Room " + _toDisplayString(_ctx.roomNumToChar(_ctx.roomCount + 1)) + " - New Room ", 1),
                  _createElementVNode("div", {
                    class: "room-inner",
                    dropzone: "move",
                    onDragenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dragOver($event, _ctx.roomNumMax + 1))),
                    onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                    onDragleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dragOut($event))),
                    onDrop: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dragDrop(_ctx.roomNumMax + 1)))
                  }, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", {
                        class: "pax-button pax-button-add",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addPassenger(_ctx.roomNumMax + 1))),
                        title: "Click to add passenger"
                      }, _hoisted_70)
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_71, [
            (_ctx.trip)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-success m-2",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitSignups && _ctx.submitSignups(...args)))
                }, " SUBMIT REQUEST TO SIGN UP TO THIS TOUR "))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              href: `/${_ctx.$route.params.gtUrl}/${_ctx.$route.params.tourId}`,
              class: "btn btn-secondary m-2"
            }, "GO BACK TO TOUR PAGE", 8, _hoisted_72)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.submitted)
      ? (_openBlock(), _createElementBlock("section", _hoisted_73, [
          _hoisted_74,
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (roomSignups, roomNum, roomIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "room-container w-100",
                  key: roomNum
                }, [
                  _createElementVNode("div", _hoisted_78, " Room " + _toDisplayString(_ctx.roomNumToChar(roomIdx + 1)) + " - " + _toDisplayString(_ctx.roomType(roomSignups.length)), 1),
                  _createElementVNode("div", _hoisted_79, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomSignups, (signup) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "pax-container",
                        key: signup
                      }, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("span", _hoisted_81, _toDisplayString(signup.firstName || signup.lastName
                    ? signup.firstName + " " + signup.lastName
                    : "New Passenger"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("table", _hoisted_83, [
                            _createElementVNode("tr", null, [
                              _hoisted_84,
                              _createElementVNode("td", _hoisted_85, _toDisplayString(signup.email), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_86,
                              _createElementVNode("td", _hoisted_87, _toDisplayString(_ctx.formatPhone(signup.phone)), 1)
                            ]),
                            (_ctx.trip?.casinoManifest)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_88,
                                    _createElementVNode("td", _hoisted_89, [
                                      _createTextVNode(_toDisplayString(signup.addressLine1), 1),
                                      (signup.AddressLine2)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_90, [
                                            _hoisted_91,
                                            _createTextVNode(_toDisplayString(signup.addressLine2), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_92,
                                    _createElementVNode("td", _hoisted_93, _toDisplayString(signup.city) + ", " + _toDisplayString(signup.state), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_94,
                                    _createElementVNode("td", _hoisted_95, _toDisplayString(signup.postalCode), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_96,
                                    _createElementVNode("td", _hoisted_97, _toDisplayString(signup.dateOfBirth.toLocalDateString("en-US")), 1)
                                  ])
                                ], 64))
                              : _createCommentVNode("", true),
                            _createElementVNode("tr", null, [
                              _hoisted_98,
                              _createElementVNode("td", _hoisted_99, _toDisplayString(signup.notes), 1)
                            ]),
                            (roomSignups.length > 1)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_100, [
                                  _createElementVNode("td", _hoisted_101, [
                                    _hoisted_102,
                                    _createTextVNode(" " + _toDisplayString(signup.twoBeds ? "Yes" : "No"), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_103, [
                                _hoisted_104,
                                _createTextVNode(" " + _toDisplayString(signup.futureTripsNotify ? "Yes" : "No"), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("a", {
              href: `/${_ctx.$route.params.gtUrl}/${_ctx.$route.params.tourId}`,
              class: "btn btn-primary m-2"
            }, "GO BACK TO TOUR PAGE", 8, _hoisted_106)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ModalLoading, { key: 5 }))
      : _createCommentVNode("", true),
    (_ctx.errorMessage != null)
      ? (_openBlock(), _createBlock(_component_ModalErrorMessage, {
          key: 6,
          message: _ctx.errorMessage,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.errorMessage = null))
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 64))
}